import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { BasicForm } from 'src/app/shared/basic-form';

@Component({
  selector: 'app-insurane-period',
  templateUrl: './insurane-period.component.html',
  styleUrls: ['./insurane-period.component.scss']
})
export class InsuranePeriodComponent extends BasicForm implements OnInit {
  minstartDate: Date;
  maxstartDate: Date;
  minendDate: Date;
  maxendDate: Date;

  ngOnInit(): void {

    this.formAlias = 'InsurancePeriod';
    this.form = this.fb.group({
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]]
    });

    this.minstartDate = new Date();
    this.maxstartDate = new Date();
    this.minendDate = new Date();
    this.maxendDate = new Date();
    this.maxstartDate.setDate(this.maxstartDate.getDate() + 180);
    this.minendDate.setDate(this.minendDate.getDate() + 1);
    this.maxendDate.setDate(this.maxendDate.getDate() + 365);

    this.form.get('startDate').valueChanges.pipe(take(1)).subscribe(value => {
      if (typeof value === 'string') {
        this.form.get('startDate').setValue(new Date(this.formData.startDate));
      }
    });
    this.form.get('endDate').valueChanges.pipe(take(1)).subscribe(value => {

      if (typeof value === 'string') {
        this.form.get('endDate').setValue(new Date(this.formData.endDate));
      }
    });

    this.form.patchValue(this.formData);
  }

  changeStartDate(value) {
    var nextDay = new Date(value);
    nextDay.setDate(nextDay.getDate() + 1);
    this.minendDate = nextDay;
  }

  formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }

}
